import theme from "../../theme";

export const h1Style = { fontWeight: 700, fontSize: 26, marginBottom: 0, color: theme.palette.vbBlue.darkdark };

// billing switch styles
export const billingSwitchSelected = { color: "#000000", fontWeight: 600, width: 60 };
export const billingSwitchUnselected = { color: theme.palette.grey[400], fontWeight: 400, width: 60 };
